<div class="security-camera">Camera Feed 1</div>
<div class="security-camera">Camera Feed 2</div>
<div class="security-camera">Camera Feed 3</div>
<div class="security-camera">Camera Feed 4</div>
